import { namespace } from 'vuex-class';
import { IThresholdState } from './threshold.types';

export const ThresholdNamespace = namespace('threshold');

export const getDefaultState = (): IThresholdState => ({
  showActiveDocumentThresholdModal: false,
  showActiveDocumentThresholdPromptBar: false,
  hasReachedActiveDocumentThreshold: false,
  activeDocumentThreshold: null,
  dismissedActiveDocumentThresholdPromptBar: false,
});

export enum EThresholdGetter {
  IsNearThresholdLimit = 'isNearThresholdLimit',
}

export enum EThresholdAction {
  EvaluateActiveDocumentThreshold = 'evaluateActiveDocumentThreshold',
  EvaluateActiveDocumentThresholdSuccess = 'evaluateActiveDocumentThresholdSuccess',
  EvaluateActiveDocumentThresholdFailed = 'evaluateActiveDocumentThresholdFailed',
  GetActiveDocumentThreshold = 'getActiveDocumentThreshold',
  GetActiveDocumentThresholdSuccess = 'getActiveDocumentThresholdSuccess',
  GetActiveDocumentThresholdFailed = 'getActiveDocumentThresholdSuccessFailed',
  SetShowActiveDocumentThresholdModal = 'setShowActiveDocumentThresholdModal',
  SetShowActiveDocumentThresholdPromptBar = 'setShowActiveDocumentThresholdPromptBar',
  TriggerActiveDocumentThresholdPromptBar = 'triggerActiveDocumentThresholdPromptBar',
  SetDismissedActiveDocumentThresholdPromptBar = 'SetDismissedActiveDocumentThresholdPromptBar',
  ResetState = 'resetState',
}

export enum EThresholdMutation {
  SetShowActiveDocumentThresholdModal = 'setShowActiveDocumentThresholdModal',
  SetShowActiveDocumentThresholdPromptBar = 'setShowActiveDocumentThresholdPromptBar',
  SetHasReachedActiveDocumentThreshold = 'setHasReachedActiveDocumentThreshold',
  SetActiveDocumentThreshold = 'setActiveDocumentThreshold',
  SetDismissedActiveDocumentThresholdPromptBar = 'SetDismissedActiveDocumentThresholdPromptBar',
  SetState = 'setState',
}
